import Delivery from './delivery/DeliveryCard';

export default { Delivery };
